import {useState} from 'react';
import {
  AppBar,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Toolbar,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import {useResponsive} from '../hooks/style';
import topics from './topics/topicIndex';

const HelpDialog = ({open, handleClose}) => {
  const {isDesktop, isPhone} = useResponsive();

  const [selectedTopic, setSelectedTopic] = useState(0);
  const [menuAnchor, setMenuAnchor] = useState(null);

  const handleMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth='md'
      fullScreen={isPhone}
    >
      <DialogTitle sx={{position: 'relative'}}>
        Help Topics
        <IconButton
          onClick={handleClose}
          sx={{position: 'absolute', top: 8, right: 8}}
        >
          <CloseIcon/>
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {/* Mobile menu nav */}
        {isPhone && (
          <AppBar
            position='static'
            color='secondary'
          >
            <Toolbar>
              <IconButton
                onClick={handleMenuOpen}
                sx={{pr: 2}}
              >
                <MenuIcon/>
              </IconButton>

              {topics.find(topic => topic.id === selectedTopic).icon}

              <Typography sx={{pl: 1}}>
                {topics.find(topic => topic.id === selectedTopic).title}
              </Typography>
              
              <Menu
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={handleMenuClose}
                anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
              >
                {topics.map(topic => (
                  <MenuItem
                    key={topic.id}
                    selected={selectedTopic === topic.id}
                    onClick={() => {
                      setSelectedTopic(topic.id);
                      handleMenuClose();
                    }}
                  >
                    <ListItemIcon>
                      {topic.icon}
                    </ListItemIcon>
                    <ListItemText primary={topic.title}/>
                  </MenuItem>
                ))}
              </Menu>
            </Toolbar>
          </AppBar>
        )}

        <Box sx={{display: 'flex', height: '65vh', minHeight: 480, maxHeight: 720}}>
          {/* Desktop left nav */}
          {!isPhone && (
            <Box sx={{minWidth: 250, borderRight: 1, borderColor: 'divider', overflow: 'auto'}}>
              <List>
                {topics.map(topic => (
                  <ListItemButton
                    key={topic.id}
                    selected={selectedTopic === topic.id}
                    onClick={() => setSelectedTopic(topic.id)}
                  >
                    <ListItemIcon sx={{minWidth: '36px'}}>
                      {topic.icon}
                    </ListItemIcon>
                    <ListItemText primary={topic.title}/>
                  </ListItemButton>
                ))}
              </List>
            </Box>
          )}

          {/* Content container */}
          <Box sx={{flex: 'auto', px: 2, overflow: 'auto'}}>
            {topics.find(topic => topic.id === selectedTopic).component}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default HelpDialog;